/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as DialogIndexImport } from './routes/dialog/index'
import { Route as DialogWalletsendCallsImport } from './routes/dialog/wallet_sendCalls'
import { Route as DialogWalletrevokePermissionsImport } from './routes/dialog/wallet_revokePermissions'
import { Route as DialogWalletrevokeAdminImport } from './routes/dialog/wallet_revokeAdmin'
import { Route as DialogWalletprepareUpgradeAccountImport } from './routes/dialog/wallet_prepareUpgradeAccount'
import { Route as DialogWalletgrantPermissionsImport } from './routes/dialog/wallet_grantPermissions'
import { Route as DialogWalletgrantAdminImport } from './routes/dialog/wallet_grantAdmin'
import { Route as DialogWalletconnectImport } from './routes/dialog/wallet_connect'
import { Route as DialogWalletaddFundsImport } from './routes/dialog/wallet_addFunds'
import { Route as DialogSuccessImport } from './routes/dialog/success'
import { Route as DialogPlaygroundImport } from './routes/dialog/playground'
import { Route as DialogPersonalsignImport } from './routes/dialog/personal_sign'
import { Route as DialogPendingImport } from './routes/dialog/pending'
import { Route as DialogEthsignTypedDatav4Import } from './routes/dialog/eth_signTypedData_v4'
import { Route as DialogEthsendTransactionImport } from './routes/dialog/eth_sendTransaction'
import { Route as DialogEthrequestAccountsImport } from './routes/dialog/eth_requestAccounts'
import { Route as DialogAccountverifyEmailImport } from './routes/dialog/account_verifyEmail'
import { Route as DialogSplatImport } from './routes/dialog/$'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const DialogIndexRoute = DialogIndexImport.update({
  id: '/dialog/',
  path: '/dialog/',
  getParentRoute: () => rootRoute,
} as any)

const DialogWalletsendCallsRoute = DialogWalletsendCallsImport.update({
  id: '/dialog/wallet_sendCalls',
  path: '/dialog/wallet_sendCalls',
  getParentRoute: () => rootRoute,
} as any)

const DialogWalletrevokePermissionsRoute =
  DialogWalletrevokePermissionsImport.update({
    id: '/dialog/wallet_revokePermissions',
    path: '/dialog/wallet_revokePermissions',
    getParentRoute: () => rootRoute,
  } as any)

const DialogWalletrevokeAdminRoute = DialogWalletrevokeAdminImport.update({
  id: '/dialog/wallet_revokeAdmin',
  path: '/dialog/wallet_revokeAdmin',
  getParentRoute: () => rootRoute,
} as any)

const DialogWalletprepareUpgradeAccountRoute =
  DialogWalletprepareUpgradeAccountImport.update({
    id: '/dialog/wallet_prepareUpgradeAccount',
    path: '/dialog/wallet_prepareUpgradeAccount',
    getParentRoute: () => rootRoute,
  } as any)

const DialogWalletgrantPermissionsRoute =
  DialogWalletgrantPermissionsImport.update({
    id: '/dialog/wallet_grantPermissions',
    path: '/dialog/wallet_grantPermissions',
    getParentRoute: () => rootRoute,
  } as any)

const DialogWalletgrantAdminRoute = DialogWalletgrantAdminImport.update({
  id: '/dialog/wallet_grantAdmin',
  path: '/dialog/wallet_grantAdmin',
  getParentRoute: () => rootRoute,
} as any)

const DialogWalletconnectRoute = DialogWalletconnectImport.update({
  id: '/dialog/wallet_connect',
  path: '/dialog/wallet_connect',
  getParentRoute: () => rootRoute,
} as any)

const DialogWalletaddFundsRoute = DialogWalletaddFundsImport.update({
  id: '/dialog/wallet_addFunds',
  path: '/dialog/wallet_addFunds',
  getParentRoute: () => rootRoute,
} as any)

const DialogSuccessRoute = DialogSuccessImport.update({
  id: '/dialog/success',
  path: '/dialog/success',
  getParentRoute: () => rootRoute,
} as any)

const DialogPlaygroundRoute = DialogPlaygroundImport.update({
  id: '/dialog/playground',
  path: '/dialog/playground',
  getParentRoute: () => rootRoute,
} as any)

const DialogPersonalsignRoute = DialogPersonalsignImport.update({
  id: '/dialog/personal_sign',
  path: '/dialog/personal_sign',
  getParentRoute: () => rootRoute,
} as any)

const DialogPendingRoute = DialogPendingImport.update({
  id: '/dialog/pending',
  path: '/dialog/pending',
  getParentRoute: () => rootRoute,
} as any)

const DialogEthsignTypedDatav4Route = DialogEthsignTypedDatav4Import.update({
  id: '/dialog/eth_signTypedData_v4',
  path: '/dialog/eth_signTypedData_v4',
  getParentRoute: () => rootRoute,
} as any)

const DialogEthsendTransactionRoute = DialogEthsendTransactionImport.update({
  id: '/dialog/eth_sendTransaction',
  path: '/dialog/eth_sendTransaction',
  getParentRoute: () => rootRoute,
} as any)

const DialogEthrequestAccountsRoute = DialogEthrequestAccountsImport.update({
  id: '/dialog/eth_requestAccounts',
  path: '/dialog/eth_requestAccounts',
  getParentRoute: () => rootRoute,
} as any)

const DialogAccountverifyEmailRoute = DialogAccountverifyEmailImport.update({
  id: '/dialog/account_verifyEmail',
  path: '/dialog/account_verifyEmail',
  getParentRoute: () => rootRoute,
} as any)

const DialogSplatRoute = DialogSplatImport.update({
  id: '/dialog/$',
  path: '/dialog/$',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dialog/$': {
      id: '/dialog/$'
      path: '/dialog/$'
      fullPath: '/dialog/$'
      preLoaderRoute: typeof DialogSplatImport
      parentRoute: typeof rootRoute
    }
    '/dialog/account_verifyEmail': {
      id: '/dialog/account_verifyEmail'
      path: '/dialog/account_verifyEmail'
      fullPath: '/dialog/account_verifyEmail'
      preLoaderRoute: typeof DialogAccountverifyEmailImport
      parentRoute: typeof rootRoute
    }
    '/dialog/eth_requestAccounts': {
      id: '/dialog/eth_requestAccounts'
      path: '/dialog/eth_requestAccounts'
      fullPath: '/dialog/eth_requestAccounts'
      preLoaderRoute: typeof DialogEthrequestAccountsImport
      parentRoute: typeof rootRoute
    }
    '/dialog/eth_sendTransaction': {
      id: '/dialog/eth_sendTransaction'
      path: '/dialog/eth_sendTransaction'
      fullPath: '/dialog/eth_sendTransaction'
      preLoaderRoute: typeof DialogEthsendTransactionImport
      parentRoute: typeof rootRoute
    }
    '/dialog/eth_signTypedData_v4': {
      id: '/dialog/eth_signTypedData_v4'
      path: '/dialog/eth_signTypedData_v4'
      fullPath: '/dialog/eth_signTypedData_v4'
      preLoaderRoute: typeof DialogEthsignTypedDatav4Import
      parentRoute: typeof rootRoute
    }
    '/dialog/pending': {
      id: '/dialog/pending'
      path: '/dialog/pending'
      fullPath: '/dialog/pending'
      preLoaderRoute: typeof DialogPendingImport
      parentRoute: typeof rootRoute
    }
    '/dialog/personal_sign': {
      id: '/dialog/personal_sign'
      path: '/dialog/personal_sign'
      fullPath: '/dialog/personal_sign'
      preLoaderRoute: typeof DialogPersonalsignImport
      parentRoute: typeof rootRoute
    }
    '/dialog/playground': {
      id: '/dialog/playground'
      path: '/dialog/playground'
      fullPath: '/dialog/playground'
      preLoaderRoute: typeof DialogPlaygroundImport
      parentRoute: typeof rootRoute
    }
    '/dialog/success': {
      id: '/dialog/success'
      path: '/dialog/success'
      fullPath: '/dialog/success'
      preLoaderRoute: typeof DialogSuccessImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_addFunds': {
      id: '/dialog/wallet_addFunds'
      path: '/dialog/wallet_addFunds'
      fullPath: '/dialog/wallet_addFunds'
      preLoaderRoute: typeof DialogWalletaddFundsImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_connect': {
      id: '/dialog/wallet_connect'
      path: '/dialog/wallet_connect'
      fullPath: '/dialog/wallet_connect'
      preLoaderRoute: typeof DialogWalletconnectImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_grantAdmin': {
      id: '/dialog/wallet_grantAdmin'
      path: '/dialog/wallet_grantAdmin'
      fullPath: '/dialog/wallet_grantAdmin'
      preLoaderRoute: typeof DialogWalletgrantAdminImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_grantPermissions': {
      id: '/dialog/wallet_grantPermissions'
      path: '/dialog/wallet_grantPermissions'
      fullPath: '/dialog/wallet_grantPermissions'
      preLoaderRoute: typeof DialogWalletgrantPermissionsImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_prepareUpgradeAccount': {
      id: '/dialog/wallet_prepareUpgradeAccount'
      path: '/dialog/wallet_prepareUpgradeAccount'
      fullPath: '/dialog/wallet_prepareUpgradeAccount'
      preLoaderRoute: typeof DialogWalletprepareUpgradeAccountImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_revokeAdmin': {
      id: '/dialog/wallet_revokeAdmin'
      path: '/dialog/wallet_revokeAdmin'
      fullPath: '/dialog/wallet_revokeAdmin'
      preLoaderRoute: typeof DialogWalletrevokeAdminImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_revokePermissions': {
      id: '/dialog/wallet_revokePermissions'
      path: '/dialog/wallet_revokePermissions'
      fullPath: '/dialog/wallet_revokePermissions'
      preLoaderRoute: typeof DialogWalletrevokePermissionsImport
      parentRoute: typeof rootRoute
    }
    '/dialog/wallet_sendCalls': {
      id: '/dialog/wallet_sendCalls'
      path: '/dialog/wallet_sendCalls'
      fullPath: '/dialog/wallet_sendCalls'
      preLoaderRoute: typeof DialogWalletsendCallsImport
      parentRoute: typeof rootRoute
    }
    '/dialog/': {
      id: '/dialog/'
      path: '/dialog'
      fullPath: '/dialog'
      preLoaderRoute: typeof DialogIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dialog/$': typeof DialogSplatRoute
  '/dialog/account_verifyEmail': typeof DialogAccountverifyEmailRoute
  '/dialog/eth_requestAccounts': typeof DialogEthrequestAccountsRoute
  '/dialog/eth_sendTransaction': typeof DialogEthsendTransactionRoute
  '/dialog/eth_signTypedData_v4': typeof DialogEthsignTypedDatav4Route
  '/dialog/pending': typeof DialogPendingRoute
  '/dialog/personal_sign': typeof DialogPersonalsignRoute
  '/dialog/playground': typeof DialogPlaygroundRoute
  '/dialog/success': typeof DialogSuccessRoute
  '/dialog/wallet_addFunds': typeof DialogWalletaddFundsRoute
  '/dialog/wallet_connect': typeof DialogWalletconnectRoute
  '/dialog/wallet_grantAdmin': typeof DialogWalletgrantAdminRoute
  '/dialog/wallet_grantPermissions': typeof DialogWalletgrantPermissionsRoute
  '/dialog/wallet_prepareUpgradeAccount': typeof DialogWalletprepareUpgradeAccountRoute
  '/dialog/wallet_revokeAdmin': typeof DialogWalletrevokeAdminRoute
  '/dialog/wallet_revokePermissions': typeof DialogWalletrevokePermissionsRoute
  '/dialog/wallet_sendCalls': typeof DialogWalletsendCallsRoute
  '/dialog': typeof DialogIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dialog/$': typeof DialogSplatRoute
  '/dialog/account_verifyEmail': typeof DialogAccountverifyEmailRoute
  '/dialog/eth_requestAccounts': typeof DialogEthrequestAccountsRoute
  '/dialog/eth_sendTransaction': typeof DialogEthsendTransactionRoute
  '/dialog/eth_signTypedData_v4': typeof DialogEthsignTypedDatav4Route
  '/dialog/pending': typeof DialogPendingRoute
  '/dialog/personal_sign': typeof DialogPersonalsignRoute
  '/dialog/playground': typeof DialogPlaygroundRoute
  '/dialog/success': typeof DialogSuccessRoute
  '/dialog/wallet_addFunds': typeof DialogWalletaddFundsRoute
  '/dialog/wallet_connect': typeof DialogWalletconnectRoute
  '/dialog/wallet_grantAdmin': typeof DialogWalletgrantAdminRoute
  '/dialog/wallet_grantPermissions': typeof DialogWalletgrantPermissionsRoute
  '/dialog/wallet_prepareUpgradeAccount': typeof DialogWalletprepareUpgradeAccountRoute
  '/dialog/wallet_revokeAdmin': typeof DialogWalletrevokeAdminRoute
  '/dialog/wallet_revokePermissions': typeof DialogWalletrevokePermissionsRoute
  '/dialog/wallet_sendCalls': typeof DialogWalletsendCallsRoute
  '/dialog': typeof DialogIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/dialog/$': typeof DialogSplatRoute
  '/dialog/account_verifyEmail': typeof DialogAccountverifyEmailRoute
  '/dialog/eth_requestAccounts': typeof DialogEthrequestAccountsRoute
  '/dialog/eth_sendTransaction': typeof DialogEthsendTransactionRoute
  '/dialog/eth_signTypedData_v4': typeof DialogEthsignTypedDatav4Route
  '/dialog/pending': typeof DialogPendingRoute
  '/dialog/personal_sign': typeof DialogPersonalsignRoute
  '/dialog/playground': typeof DialogPlaygroundRoute
  '/dialog/success': typeof DialogSuccessRoute
  '/dialog/wallet_addFunds': typeof DialogWalletaddFundsRoute
  '/dialog/wallet_connect': typeof DialogWalletconnectRoute
  '/dialog/wallet_grantAdmin': typeof DialogWalletgrantAdminRoute
  '/dialog/wallet_grantPermissions': typeof DialogWalletgrantPermissionsRoute
  '/dialog/wallet_prepareUpgradeAccount': typeof DialogWalletprepareUpgradeAccountRoute
  '/dialog/wallet_revokeAdmin': typeof DialogWalletrevokeAdminRoute
  '/dialog/wallet_revokePermissions': typeof DialogWalletrevokePermissionsRoute
  '/dialog/wallet_sendCalls': typeof DialogWalletsendCallsRoute
  '/dialog/': typeof DialogIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dialog/$'
    | '/dialog/account_verifyEmail'
    | '/dialog/eth_requestAccounts'
    | '/dialog/eth_sendTransaction'
    | '/dialog/eth_signTypedData_v4'
    | '/dialog/pending'
    | '/dialog/personal_sign'
    | '/dialog/playground'
    | '/dialog/success'
    | '/dialog/wallet_addFunds'
    | '/dialog/wallet_connect'
    | '/dialog/wallet_grantAdmin'
    | '/dialog/wallet_grantPermissions'
    | '/dialog/wallet_prepareUpgradeAccount'
    | '/dialog/wallet_revokeAdmin'
    | '/dialog/wallet_revokePermissions'
    | '/dialog/wallet_sendCalls'
    | '/dialog'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dialog/$'
    | '/dialog/account_verifyEmail'
    | '/dialog/eth_requestAccounts'
    | '/dialog/eth_sendTransaction'
    | '/dialog/eth_signTypedData_v4'
    | '/dialog/pending'
    | '/dialog/personal_sign'
    | '/dialog/playground'
    | '/dialog/success'
    | '/dialog/wallet_addFunds'
    | '/dialog/wallet_connect'
    | '/dialog/wallet_grantAdmin'
    | '/dialog/wallet_grantPermissions'
    | '/dialog/wallet_prepareUpgradeAccount'
    | '/dialog/wallet_revokeAdmin'
    | '/dialog/wallet_revokePermissions'
    | '/dialog/wallet_sendCalls'
    | '/dialog'
  id:
    | '__root__'
    | '/'
    | '/dialog/$'
    | '/dialog/account_verifyEmail'
    | '/dialog/eth_requestAccounts'
    | '/dialog/eth_sendTransaction'
    | '/dialog/eth_signTypedData_v4'
    | '/dialog/pending'
    | '/dialog/personal_sign'
    | '/dialog/playground'
    | '/dialog/success'
    | '/dialog/wallet_addFunds'
    | '/dialog/wallet_connect'
    | '/dialog/wallet_grantAdmin'
    | '/dialog/wallet_grantPermissions'
    | '/dialog/wallet_prepareUpgradeAccount'
    | '/dialog/wallet_revokeAdmin'
    | '/dialog/wallet_revokePermissions'
    | '/dialog/wallet_sendCalls'
    | '/dialog/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DialogSplatRoute: typeof DialogSplatRoute
  DialogAccountverifyEmailRoute: typeof DialogAccountverifyEmailRoute
  DialogEthrequestAccountsRoute: typeof DialogEthrequestAccountsRoute
  DialogEthsendTransactionRoute: typeof DialogEthsendTransactionRoute
  DialogEthsignTypedDatav4Route: typeof DialogEthsignTypedDatav4Route
  DialogPendingRoute: typeof DialogPendingRoute
  DialogPersonalsignRoute: typeof DialogPersonalsignRoute
  DialogPlaygroundRoute: typeof DialogPlaygroundRoute
  DialogSuccessRoute: typeof DialogSuccessRoute
  DialogWalletaddFundsRoute: typeof DialogWalletaddFundsRoute
  DialogWalletconnectRoute: typeof DialogWalletconnectRoute
  DialogWalletgrantAdminRoute: typeof DialogWalletgrantAdminRoute
  DialogWalletgrantPermissionsRoute: typeof DialogWalletgrantPermissionsRoute
  DialogWalletprepareUpgradeAccountRoute: typeof DialogWalletprepareUpgradeAccountRoute
  DialogWalletrevokeAdminRoute: typeof DialogWalletrevokeAdminRoute
  DialogWalletrevokePermissionsRoute: typeof DialogWalletrevokePermissionsRoute
  DialogWalletsendCallsRoute: typeof DialogWalletsendCallsRoute
  DialogIndexRoute: typeof DialogIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DialogSplatRoute: DialogSplatRoute,
  DialogAccountverifyEmailRoute: DialogAccountverifyEmailRoute,
  DialogEthrequestAccountsRoute: DialogEthrequestAccountsRoute,
  DialogEthsendTransactionRoute: DialogEthsendTransactionRoute,
  DialogEthsignTypedDatav4Route: DialogEthsignTypedDatav4Route,
  DialogPendingRoute: DialogPendingRoute,
  DialogPersonalsignRoute: DialogPersonalsignRoute,
  DialogPlaygroundRoute: DialogPlaygroundRoute,
  DialogSuccessRoute: DialogSuccessRoute,
  DialogWalletaddFundsRoute: DialogWalletaddFundsRoute,
  DialogWalletconnectRoute: DialogWalletconnectRoute,
  DialogWalletgrantAdminRoute: DialogWalletgrantAdminRoute,
  DialogWalletgrantPermissionsRoute: DialogWalletgrantPermissionsRoute,
  DialogWalletprepareUpgradeAccountRoute:
    DialogWalletprepareUpgradeAccountRoute,
  DialogWalletrevokeAdminRoute: DialogWalletrevokeAdminRoute,
  DialogWalletrevokePermissionsRoute: DialogWalletrevokePermissionsRoute,
  DialogWalletsendCallsRoute: DialogWalletsendCallsRoute,
  DialogIndexRoute: DialogIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dialog/$",
        "/dialog/account_verifyEmail",
        "/dialog/eth_requestAccounts",
        "/dialog/eth_sendTransaction",
        "/dialog/eth_signTypedData_v4",
        "/dialog/pending",
        "/dialog/personal_sign",
        "/dialog/playground",
        "/dialog/success",
        "/dialog/wallet_addFunds",
        "/dialog/wallet_connect",
        "/dialog/wallet_grantAdmin",
        "/dialog/wallet_grantPermissions",
        "/dialog/wallet_prepareUpgradeAccount",
        "/dialog/wallet_revokeAdmin",
        "/dialog/wallet_revokePermissions",
        "/dialog/wallet_sendCalls",
        "/dialog/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dialog/$": {
      "filePath": "dialog/$.tsx"
    },
    "/dialog/account_verifyEmail": {
      "filePath": "dialog/account_verifyEmail.tsx"
    },
    "/dialog/eth_requestAccounts": {
      "filePath": "dialog/eth_requestAccounts.tsx"
    },
    "/dialog/eth_sendTransaction": {
      "filePath": "dialog/eth_sendTransaction.tsx"
    },
    "/dialog/eth_signTypedData_v4": {
      "filePath": "dialog/eth_signTypedData_v4.tsx"
    },
    "/dialog/pending": {
      "filePath": "dialog/pending.tsx"
    },
    "/dialog/personal_sign": {
      "filePath": "dialog/personal_sign.tsx"
    },
    "/dialog/playground": {
      "filePath": "dialog/playground.tsx"
    },
    "/dialog/success": {
      "filePath": "dialog/success.tsx"
    },
    "/dialog/wallet_addFunds": {
      "filePath": "dialog/wallet_addFunds.tsx"
    },
    "/dialog/wallet_connect": {
      "filePath": "dialog/wallet_connect.tsx"
    },
    "/dialog/wallet_grantAdmin": {
      "filePath": "dialog/wallet_grantAdmin.tsx"
    },
    "/dialog/wallet_grantPermissions": {
      "filePath": "dialog/wallet_grantPermissions.tsx"
    },
    "/dialog/wallet_prepareUpgradeAccount": {
      "filePath": "dialog/wallet_prepareUpgradeAccount.tsx"
    },
    "/dialog/wallet_revokeAdmin": {
      "filePath": "dialog/wallet_revokeAdmin.tsx"
    },
    "/dialog/wallet_revokePermissions": {
      "filePath": "dialog/wallet_revokePermissions.tsx"
    },
    "/dialog/wallet_sendCalls": {
      "filePath": "dialog/wallet_sendCalls.tsx"
    },
    "/dialog/": {
      "filePath": "dialog/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
